module.exports = __webpack_public_path__ + "img/chr_ts_21.da339f61.png";